<div style="position: relative;" class="fuse-white-bg happ-left-border" fxLayout="column" *ngIf="!field.hide">
  <mat-form-field appearance="outline" floatLabel="always" [class]="(errorMessage) ? 'mb-12' : ''" fxFlex>
      <mat-label>{{field.title | translate }}</mat-label>
      <mat-select (selectionChange)="onChange(model)" fxFlex placeholder="{{field.title | translate}}" [disabled]="field.showdisablecontroltype=='true' || field.disable" [hidden]="field.hidden" [(ngModel)]="model">
          <mat-option *ngFor="let option of field.options" [value]="(option.value || option.title) | translate">
              {{ option.title || option.value }}
          </mat-option>
      </mat-select>
      <mat-hint>
        <div class="error-message" *ngIf="errorMessage && (!min_error && !max_error)">
          {{ errorMessage | translate }}
        </div>
        <div class="error-message" *ngIf="min_error">
            {{ errorMessage | translate }} {{ field.min_length }}
        </div>
        <div class="error-message" *ngIf="max_error">
            {{ errorMessage | translate }} {{ field.max_length }}
        </div>
      </mat-hint>
  </mat-form-field>
  <div class="happ-field-description" *ngIf="field.allow_description && field.description"> {{ field.description }} </div>
</div>